import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { Team } from "../team";
import { type SubTeam } from "./entity";

export const SubTeamEntityConfig: HyperEntityConfig<SubTeam> = {
  id: {
    teamId: true,
    subTeamId: true,
  },
  allowApiCrud: Roles.AdminsAndManager,
  async apiPrefilterPerRole(filter) {
    filter(Roles.All, {
      team: { $is: await copyApiPrefilterPerRole(Team) },
    });
  },

  allowInsertPerRole(allow) {
    allow([Roles.Admin, Roles.SuperAdmin], (entity) =>
      doesExist(Team, {
        id: entity.teamId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow([Roles.Admin, Roles.SuperAdmin], (entity) =>
      doesExist(Team, {
        id: entity.teamId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },
  __preventLogger: true, // Prevent development security logger from logging this entity
};
